import { ChannelsNames } from '../Channels';
import { blipDomainUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, } from 'app.constants';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client';
// Controllers
import { ChannelBaseController } from '../ChannelBaseController';
export class MessengerController extends ChannelBaseController {
    static $inject = ['$window', 'application', 'ApplicationService2', 'AccountService2', 'ChannelsService', 'LoadingService', 'TranslateService', 'AuthenticationService'];
    constructor($window, application, ApplicationService2, AccountService2, ChannelsService, LoadingService, TranslateService, AuthenticationService) {
        'ngInject';
        super(ChannelsNames.Messenger, ChannelsService, ApplicationService2, application);
        this.$window = $window;
        this.application = application;
        this.ApplicationService2 = ApplicationService2;
        this.AccountService2 = AccountService2;
        this.ChannelsService = ChannelsService;
        this.LoadingService = LoadingService;
        this.TranslateService = TranslateService;
        this.AuthenticationService = AuthenticationService;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.readyToRender = false;
        this.isMasterApplication = false;
    }
    async $onInit() {
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.currentUser = await this.AccountService2.me();
        this.currentLanguage = this.TranslateService.getCurrentLanguage();
        const account = await this.ApplicationService2.getAccount();
        this.botIdentity = account.identity;
        const application = await this.ApplicationService2.getApplication(this.botIdentity.split('@')[0]);
        this.isMasterApplication = this.ApplicationService2.isThisMasterApplication(application);
        this.authToken = useDelegation ? this.AuthenticationService.token : application.accessKey;
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
        this.authEmail = this.AuthenticationService.email;
        this.LoadingService.stopLoading();
        this.readyToRender = true;
    }
}
MessengerController.$inject = ['$window', 'application', 'ApplicationService2', 'AccountService2', 'ChannelsService', 'LoadingService', 'TranslateService', 'AuthenticationService'];
